<template>
  <div class="modal-card"
       style="width: 500px">
    <header class="modal-card-head is-small">
      <p class="modal-card-title" style="text-align: center;">カスタマー別特別料金更新</p>
      <span class="v-icon-close" style="cursor: pointer;"
            @click="$emit('close')">
        <b-icon size="is-medium"
                pack="fa"
                icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="group-column">
        <div class="group-field">
          <div class="field-child">
            <p class="field-label">顧客</p>
            <p class="field-value">{{ item.customerId }}</p>
          </div>

          <div class="field-child">
            <p class="field-label">顧客名</p>
            <p class="field-value">{{ item.customerName }}</p>
          </div>
        </div>
      </div>
      <div class="group-column">
        <div class="group-field">
          <div class="field-child-2">
            <p class="field-label">Grade</p>
            <p class="field-value">{{ item.customerGradeName }}</p>
          </div>

          <div class="field-child-4">
            <p class="field-label">上乗せ金額</p>
            <p class="field-value">{{ item.customerGradeFee | formatNumber }}</p>
          </div>

          <div class="field-child-4">
            <p class="field-label">Adjust Fee</p>
            <p class="field-value">{{ item.customerAdjustFee |  formatNumber}}</p>
          </div>
        </div>
      </div>
      <div class="group-column">
        <div class="field">
          <p class="field-label">請求金額</p>
          <p class="field-value">{{ item.customerTotalFee | formatNumber }}</p>
        </div>
      </div>

      <div class="group-column">
        <div class="field">
          <p class="field-label">Adjust Fee 更新</p>
          <b-input class="input-setting-fee"
                   v-model="setting_fee_new" />

        </div>
        <span style="color: red; font-size: 15;">{{ msgSettingFee }}</span>
      </div>

      <div class="group-column">
        <b-button class="field field-button"
                  label="更新"
                  @click="updateCustomerFee();" />
      </div>
    </section>
  </div>
</template>

<script>
import jcPackage from '@/repositories/jcPackage';
const regexFormatNumber = /^-?\d+$/ ;
const regexEmppty = /^$/;
export default {
  props: [
    'item', 'token'
  ],
  data: () => ({
    setting_fee_new: '',
    errSettingFee: '',
    msgSettingFee: ''
  }),
  computed: {

  },
  methods: {
    updateCustomerFee() {

      if (regexEmppty.test(this.setting_fee_new)) {
        this.errSettingFee = 'is-danger';
        this.msgSettingFee = 'AdjustFee更新を入力してください。';
        return;
      } else {
        if (regexFormatNumber.test(this.setting_fee_new)) {
          this.errSettingFee = '';
          this.msgSettingFee = '';
        } else {
          this.errSettingFee = 'is-danger';
          this.msgSettingFee = '数字のみ入力してください。';
          return;
        }
      }

      const params = {
        setting_fee_id: this.item.dataFee.customerPriceFee?this.item.dataFee.customerPriceFee.setting_fee_id : '',
        setting_fee: this.setting_fee_new,
        auction_place_id: this.item.placeId,
        from_satellite_id: this.item.satelliteId,
        yard_record_id: this.item.yardId,
        customer_id: this.item.customerIdSearch,
        place_yard_type: this.item.isSearchAuction
      };
      jcPackage
        .updateFeeCustomer(
          this.token,
          params
        )
        .then((rs) => {
          this.item.customerAdjustFee = this.setting_fee_new;
          this.$emit('close');
        })
        .catch((err) => {
          console.log('updateFeeCustomer', err);
        });
    }
  },
};
</script>

<style>
.group-column {
  width: 80%;
  margin: auto;
  padding: 0.5rem 0.75rem !important;
  display: block;
}

.group-column .field {
  width: 100%;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.group-column .field p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.field-value {
  border-top: 1px solid #b5b5b5;
  background-color: #d7d7d7;
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.group-field {
  display: flex;
  gap: 5%;
}

.field-child {
  width: 50%;
  margin-bottom: 0;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.field-child-2{
  width: 20%;
  margin-bottom: 0;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.field-child-4{
  width: 40%;
  margin-bottom: 0;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.field-child p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.input-setting-fee input {
  border: none;
  border-top: 1px solid #b5b5b5;
  border-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: none;
  text-align: center;
}

.field-label {
  font-weight: 600;
  text-align: center;
  margin: auto;
}

.field-button {
  width: 25% !important;
  margin-left: 40%;
}
</style>
